import React from "react";
import { observer } from "mobx-react-lite";
import { buildFlags, buildSellerRemarks } from "@/utils/OrderUtils";
import OrderDTO from "@/dto/order/OrderDTO";

interface SellerRemarksProps {
    order: OrderDTO;
}

const SellerRemarks: React.FC<SellerRemarksProps> = observer(function (props) {
    const { order } = props;

    if (!order.sellerRemarks) {
        return null;
    }

    const { localFlag, flag, content, localContent } = order.sellerRemarks || {};

    if (!(localFlag || flag || content || localContent)) {
        return null;
    }

    return (
        <p className="seller-remarks">
            备注：
            {buildFlags(order)}
            {buildSellerRemarks(order)}
            {order?.sellerRemarks?.content && order?.sellerRemarks?.localContent && (
                <span className="small text-light2 ml5">(平台备注：{order.sellerRemarks.content})</span>
            )}
        </p>
    );
});

export default SellerRemarks;
